import { Checkbox, FormField, FormItem, FormMessage, Label } from "@egaranti/components";

import { useTranslation } from "react-i18next";

/**
 * EPS-4971 — Plan tanımındaki "Tahsilat Yöntemi" alanı. Plan oluşturma ve plan
 * düzenleme ekranlarının ikisinde de aynı kurallar geçerli olduğu için tek bileşen:
 * en az bir yöntem seçili olmak zorunda, ikisi birden seçilebilir.
 *
 * Yöntem satışta hangi aksiyonun görüneceğini belirliyor: ONLINE seçili planlarda
 * ödeme linki gönderilebilir, yalnızca SELLER seçili planlarda bayi kendisi tahsil eder.
 */
export const COLLECTION_TYPES = {
  SELLER: "SELLER",
  ONLINE: "ONLINE",
};

export const DEFAULT_COLLECTION_TYPES = [COLLECTION_TYPES.SELLER];

/**
 * BE eski planlarda bu alanı boş bırakabiliyor (baremli plan yolu kolonu hiç
 * yazmıyordu) — bugüne kadarki tek davranış bayi tahsilatıydı.
 */
export const normalizeCollectionTypes = (value) =>
  Array.isArray(value) && value.length > 0 ? value : DEFAULT_COLLECTION_TYPES;

const CollectionTypesField = ({ control }) => {
  const { t } = useTranslation();

  const options = [
    {
      value: COLLECTION_TYPES.SELLER,
      label: t("extendedWarranties.collectionType.seller", "Bayi Tahsilatı"),
    },
    {
      value: COLLECTION_TYPES.ONLINE,
      label: t(
        "extendedWarranties.collectionType.online",
        "Online Ödeme Linki",
      ),
    },
  ];

  return (
    <FormField
      control={control}
      name="collectionTypes"
      render={({ field }) => {
        const selected = Array.isArray(field.value) ? field.value : [];
        // Son seçili yöntem kaldırılamaz: alan zorunlu, boş bir plan satılamaz.
        const toggle = (value) =>
          field.onChange(
            selected.includes(value)
              ? selected.filter((item) => item !== value)
              : [...selected, value],
          );

        return (
          <FormItem className="col-span-2">
            <Label>
              {t("extendedWarranties.collectionType.label", "Tahsilat Yöntemi")}
              <span className="ml-0.5 text-red-500">*</span>
            </Label>
            <div className="flex items-center gap-6">
              {options.map((option) => (
                <div key={option.value} className="flex items-center gap-2">
                  <Checkbox
                    id={`collection-type-${option.value}`}
                    checked={selected.includes(option.value)}
                    onClick={() => toggle(option.value)}
                  />
                  <Label
                    htmlFor={`collection-type-${option.value}`}
                    className="!mt-0 cursor-pointer"
                  >
                    {option.label}
                  </Label>
                </div>
              ))}
            </div>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};

export default CollectionTypesField;
